<template>
  <div class="marketing-automation-form-panel-email">
    <app-form @submit="setStep">
      <marketing-automation-form-panel-section :title="$t('message.automation.message.setEmail')">
        <app-select class="marketing-automation-form-panel-email-section-select"
                    v-model="form.emailId"
                    :data-items="emailOptions"
                    :infiniteId="infiniteId"
                    :data-title="$t('message.automation.message.setEmail')"
                    data-menu-width="200px"
                     titleMaxWidth="250px"
                    infinite-loading
                    small
                    @search="searchOptions"
                    @load="loadEmailOptions"
                     />
      </marketing-automation-form-panel-section>

      <marketing-automation-form-panel-section>
        <button class="marketing-automation-form-panel-email-section-action btn btn-round btn-primary"
                type="submit">{{ actionText }}</button>
      </marketing-automation-form-panel-section>
    </app-form>
  </div>
</template>

<script>
import AppSelect from "@components/Select";
import MarketingAutomationFormPanelSection from "@components/modules/marketing/automation/form/steps/panel/section/MarketingAutomationFormPanelSection.vue";
import AppForm from "@components/form/Form.vue";

export default {
  components: {
    AppForm,
    MarketingAutomationFormPanelSection,
    AppSelect,
  },

  props: {
    step: {
      type: Object,
    },
    automationId: {
      type: String,
    },
  },

  data() {
    return {
      emailOptions: [],
      page: 0,
      filter: undefined,
      infiniteId: +new Date(),
      form: {
        emailId: undefined,
      },
    };
  },

  created() {
    if (this.step) {
      this.setInitialData();
    }
  },

  computed: {
    actionText() {
      return this.step ? this.$t('message.generics.message.save') : this.$t('message.generics.message.add');
    },
  },

  methods: {
    async setInitialData() {
      await this.loadEmailOptions();

      this.form.emailId = this.step.properties.messageId;
    },
    setStep() {
      if (this.step && this.step.id) {
        this.editStep();
      } else {
        this.addStep();
      }
    },
    async addStep() {
      const steps = await this.$api.marketing.automation.flow.addStep({
        automationId: this.automationId,
        stepType: "CHANNEL",
        previousStepId: this.step.previousStepId,
        properties: JSON.stringify({
          channelType: "EMAIL",
          messageId: this.form.emailId,
        }),
      });

      this.$emit("submit", steps);
    },
    async editStep() {
      const steps = await this.$api.marketing.automation.flow.editStep({
        stepId: this.step.id,
        automationId: this.automationId,
        stepType: "CHANNEL",
        previousStepId: this.step.previousStepId,
        properties: JSON.stringify({
          channelType: "EMAIL",
          messageId: this.form.emailId,
        }),
      });

      this.$emit("submit", steps);
    },
    searchOptions(text) {
      this.filter = text;
      this.reload();
    },
    reload() {
      this.page = 0;
      this.emailOptions = [];
      this.infiniteId++;
    },
    async loadEmailOptions($state) {
      const list = await this.$api.marketing.email.message.list({
        page: this.page,
        filter: this.filter,
        isAutomation: true,
      });

      const formatedOptionsList = list.map((email) => {
        return {
          id: email.id,
          label: email.title,
        };
      });

      this.emailOptions.push(...formatedOptionsList);

      this.page += 1;

      if (list.length) {
        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-form-panel-email {
  .marketing-automation-form-panel-email-section-select {
    margin: 0 auto;
  }

  .marketing-automation-form-panel-email-section-action {
    margin: 0 auto;
    display: block;
  }
}
</style>
